import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "panel"];
  static classes = ["active"];

  connect() {
    // Check if there's already an active tab rendered from server
    const activeTab = this.tabTargets.find(
      (tab) =>
        tab.classList.contains("text-emerald-500") ||
        tab.classList.contains("border-emerald-500")
    );

    if (activeTab) {
      // Use the server-rendered active tab
      this.showTab(activeTab.dataset.tabId);
    } else {
      // Default to signup tab for auth modal, otherwise first tab
      const defaultTab = this.tabTargets.some(
        (tab) => tab.dataset.tabId === "signup"
      )
        ? "signup"
        : this.tabTargets[0]
        ? this.tabTargets[0].dataset.tabId
        : "overview";
      this.showTab(defaultTab);
    }
  }

  show(event) {
    const tabId = event.currentTarget.dataset.tabId;
    this.showTab(tabId);
  }

  showSignin() {
    this.showTab("signin");
  }

  showTab(tabId) {
    // Hide all panels
    this.panelTargets.forEach((panel) => {
      panel.classList.add("hidden");
      panel.classList.remove("block");
    });

    // Remove active state from all tabs
    this.tabTargets.forEach((tab) => {
      tab.classList.remove(...this.activeClasses);
      tab.classList.add("border-transparent", "text-slate-400");
    });

    // Show the selected panel
    const selectedPanel = this.panelTargets.find(
      (panel) => panel.dataset.tabId === tabId
    );
    if (selectedPanel) {
      selectedPanel.classList.remove("hidden");
      selectedPanel.classList.add("block");
    }

    // Activate the selected tab
    const selectedTab = this.tabTargets.find(
      (tab) => tab.dataset.tabId === tabId
    );
    if (selectedTab) {
      selectedTab.classList.add(...this.activeClasses);
      selectedTab.classList.remove("border-transparent", "text-slate-400");
    }
  }
}
